<template>
  <div v-if="product">
    <carousel
      dir="ltr"
      :paginationActiveColor="
        $doc('html').classList.contains('dark') ? '#fff' : '#364055'
      "
      paginationColor="#36405550"
      :per-page="1"
      class="mb-4"
    >
      <slide v-for="item in product.images" :key="item.id">
        <div
          class="bg h-96 rounded-xl"
          :style="`background-image: url(${item})`"
        ></div>
      </slide>
    </carousel>
    <div class="grid-1 mb-4">
      <h1 dir="auto" class="text-2xl">{{ product.name }}</h1>
      <div dir="auto" class="start">
        <h1 class="text-3xl font-medium">{{ product.price }}</h1>
        <h6 class="text-sm mx-2">DZD</h6>
      </div>
      <div v-if="product.size" class="between">
        <h1
          v-for="item in product.size"
          :key="item.id"
          @click="size(item)"
          :class="`m-auto text-sm ${
            product.selectedSize == item ? 'border-b-2 border-slate-500' : ''
          }`"
        >
          {{ item }}
        </h1>
      </div>
      <div class="between">
        <buttonApp
          @action="favorite(product.favorite != 'true')"
          svg="like"
          :theme="`bg-slate-700 ${
            product.favorite == 'true' ? 'text-red-500' : 'text-white'
          } between rounded-xl p-2 w-10 h-10 duration-500`"
        />
        <buttonApp
          @action="cart(product.cart != 'true')"
          :text="$t('fixed.cart.title')"
          :svg="product.cart == 'true' ? 'done' : 'cart'"
          theme="btnD w-4/12"
        />
        <h2 class="text-sm text-slate-500 dark:text-slate-400 m-auto">
          {{ $t("fixed.quantity") }}
        </h2>
        <a @click="quantity(product.quantity + 1)" class="m-auto">+</a>
        <div class="w-1/12 text-center m-auto">{{ product.quantity }}</div>
        <a
          @click="product.quantity > 1 ? quantity(product.quantity - 1) : false"
          class="m-auto"
          >-</a
        >
      </div>
      <div
        v-if="product.quantity > 1"
        class="text-sm text-center m-auto text-slate-400 dark:text-slate-500 flex"
      >
        {{ $t("fixed.totalP") }}
        <a dir="auto" class="start mx-2">
          <a class="mx-2">{{ product.price * product.quantity }}</a>
          <a class="text-xs">DZD</a>
        </a>
      </div>
      <p v-if="product.description" dir="auto" class="mb-4">
        {{ product.description }}
      </p>
      <div @click="$router.push(`/category/${product.mark}`)" class="grid-1">
        <svgApp :type="product.mark" />
        <p
          class="text-sm text-center m-auto text-slate-400 dark:text-slate-500 uppercase"
        >
          {{ product.mark }} product
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import buttonApp from "@/components/buttonApp.vue";
import { Carousel, Slide } from "vue-carousel";
import svgApp from "@/components/svgApp.vue";
import { db } from "@/assets/db";

export default {
  components: {
    buttonApp,
    Carousel,
    svgApp,
    Slide,
  },
  data() {
    return {
      id: this.$route.params.id,
      product: null,
    };
  },
  async created() {
    this.product = await db.products.get({ id: this.id });
    if (!this.product.selectedSize) {
      this.product.size ? this.size(this.product.size[0]) : false;
    }
  },
  methods: {
    async favorite(data) {
      await db.products.update(this.id, { favorite: data.toString() });
      this.product.favorite = data.toString();
    },
    async cart(data) {
      await db.products.update(this.id, { cart: data.toString() });
      this.product.cart = data.toString();
    },
    async size(data) {
      await db.products.update(this.id, { selectedSize: data });
      this.product.selectedSize = data;
    },
    async quantity(data) {
      if (this.product.cart) {
        await db.products.update(this.id, { quantity: data });
      }
      this.product.quantity = data;
    },
  },
};
</script>
